<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="6" md="4" lg="4">
      <FilterSearch
        :fetchData="fetchHausefulUsers"
        label="searchByUserOrEmail"
        innerIcon="mdi-magnify"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3">
      <FilterSelect
        :fetchData="fetchHausefulUsers"
        :label="$t('filters.userType')"
        :items="hausefulUsersTypes"
        itemValue="value"
        itemText="name"
        type="userTypes"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3">
      <RealEstateSelectFilter :fetchData="fetchHausefulUsers" />
    </v-col>
    <v-col cols="12" sm="4" md="2" lg="2">
      <FilterBoolean
        :fetchData="fetchHausefulUsers"
        :label="$t('filters.deleted')"
        type="deleted"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { hausefulUsersTypes } from '@/util/enums'

import FilterBoolean from '@/components/filters/FilterBoolean'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterSelect from '@/components/filters/FilterSelect'
import RealEstateSelectFilter from '../../../components/realEstate/RealEstateSelectFilter.vue'

export default {
  name: 'HausefulUsersListFilters',

  components: {
    FilterBoolean,
    FilterSearch,
    FilterSelect,
    RealEstateSelectFilter
  },

  methods: {
    ...mapActions(['fetchHausefulUsers']),
  },

  data() {
    return {
      hausefulUsersTypes,
      orderBy: [
        { value: 'ASC', text: this.$t('filters.asc') },
        { value: 'DESC', text: this.$t('filters.desc') },
      ],
    }
  }
}
</script>
